import { useFeature } from '@growthbook/growthbook-react';

export function useLauraLogo() {
  const feature = useFeature<boolean>('laura-human-picture');

  return feature.value
    ? '/static/images/laura.png'
    : '/static/images/laura-avatar.svg';
}
